const baseUrl = `/api`;

export default baseUrl;
